const sample = [
	{
		index: '1',
		ldate: '2021-01-01',
		account: 'AMA001',
		loan_uuid: '123',
		settlement: '1000',
		discount: '0',
		interest: '0',
		debit: '60',
		credit: '10'
	},
	{
		index: '2',
		ldate: '2021-01-01',
		account: 'AMA001',
		loan_uuid: '456',
		settlement: '1000',
		discount: '0',
		interest: '0',
		debit: '60',
		credit: '10'
	},
	{
		index: '3',
		ldate: '2021-01-01',
		account: 'AMA001',
		loan_uuid: '789',
		settlement: '1000',
		discount: '0',
		interest: '0',
		debit: '60',
		credit: '10'
	},
	{
		index: '4',
		ldate: '2021-01-01',
		account: 'AMA001',
		loan_uuid: '1111',
		settlement: '1000',
		discount: '0',
		interest: '0',
		debit: '60',
		credit: '10'
	},
	{
		index: '5',
		ldate: '2021-01-01',
		account: 'AMA001',
		loan_uuid: '122223',
		settlement: '1000',
		discount: '0',
		interest: '0',
		debit: '60',
		credit: '10'
	}
]

export { sample };


